<template>

  <div v-if="showModal" @click.self="hide" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
    <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

      <div class="rg-modal-header">
        <span v-if="is_agency">Add Agency</span>
        <span v-else>
          <span v-if="!is_business">Add Business</span>

          <span v-if="is_business">{{ redirect_to_onboarding ? "Add your business" : "Add Location" }}</span>
        </span>

        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="hide"><i class="mdi mdi-close"></i></a>
      </div>

      <div class="p-6" style="height: calc(100% - 110px); overflow: auto;">

        <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">
          {{success}}
        </div>

        <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
          <div>{{ error }}</div>
        </div>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 mb-1 md:mb-0" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-5')">
                <p class="mb-1 text-xs mb-2"><strong>
                    First Name
                </strong></p>
                <input name="first_name" ref="first_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text">
            </div>

            <div class="w-full md:w-1/2 mb-3 md:mb-0">
                <p class="mb-1 text-xs mb-2"><strong>
                    Last Name
                </strong></p>
                <input name="last_name" ref="last_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text">
            </div>
        </div>

        <div class="flex flex-wrap">
            <div class="w-full mb-3 md:mb-0">
                <p class="mb-1 text-xs mb-2"><strong>
                    Email Address
                    
                    <span v-if="is_business && !loginEnabled && !redirect_to_onboarding">(optional)</span>
                </strong></p>
                <input name="email" ref="email" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text">
            </div>
        </div>

        <div class="flex flex-wrap">
            <div class="w-full md:w-2/2 mb-1 md:mb-0">
                <p class="text-xs text-gray-700 mt-2">Use our tool below to search for your business online, or enter your details manually.</p>


<vue-google-autocomplete 
  id="rg_map" 
  classname="form-control" 
  :placeholder="((is_business) ? 'Search for location' : 'Business name and main location')" 
  v-on:placechanged="selectPlace" 
  types="establishment"
  :fields="['address_components', 'adr_address', 'formatted_address', 'geometry', 'icon', 'name', 'business_status', 'photo', 'place_id', 'type', 'url', 'utc_offset', 'vicinity']"
></vue-google-autocomplete>

                <!-- <v-combobox
                    :label="((is_business) ? 'Search for location' : 'Business name and main location')"
                    v-model="autocompleteLocationModel"
                    :items="locationFoundItems"
                    :search-input.sync="locationSearchText"
                    item-text="value"
                    item-value="id"
                    hide-no-data
                    return-object
                    :filter="filterPlaces"
                    color="grey"
                    background-color="grey lighten-4"
                    @change="selectPlace()"
                    dense
                    outlined
                  >
                </v-combobox> -->
            </div>
        </div>

        <div class="flex flex-wrap">
          <div :class="'w-full mb-3 md:mb-0' + ((is_agency) ? '' : ' md:w-1/2 ') + (($vuetify.breakpoint.mobile) ? '' : ' pr-5')">
            <p class="mb-1 text-xs mb-2"><strong>
              <span v-if="is_agency">
                Agency Name
              </span>
              <span v-else>
                Company Name
              </span>
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" ref="company_name" v-model="company_name">
          </div>

          <div v-show="!is_agency" :class="((is_agency) ? 'w-full mb-3 md:mb-' : 'w-full md:w-1/2 mb-3 md:mb-0')">
            <p class="mb-1 text-xs mb-2"><strong>
              Main Keyword
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" ref="main_keyword" v-model="main_keyword">
          </div>
        </div>

        <div class="flex flex-wrap" v-show="!is_agency">
          <div :class="'w-full mb-3 md:mb-0'">
            <p class="mb-1 text-xs mb-2"><strong>
              LSA Client Account

              <a v-if="!refreshingLsaAccounts" href="javascript: void(0);" style="font-size: 12px;" @click="refreshLsaAccounts();"><i class="mdi mdi-refresh"></i> refresh list</a>

              <a v-if="refreshingLsaAccounts" href="javascript: void(0);" style="font-size: 12px;"><i class="mdi mdi-refresh"></i> refresing... please wait</a>
            </strong></p>

            <div class="text-sm" v-if="!googleConnected">
              Google is not connected yet. You can add the business now and connect it during setup.
            </div>
            <div v-else>

              <v-select v-if="!refreshingLsaAccounts" :items="googleClients" item-text="name" item-value="id"
                outlined dense
                hide-details style="width: 100%; font-size: 12px;"
                v-model="lsa_client_account_id"
                >
                
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field v-model="searchTerm" placeholder="Search" @input="searchAccounts"></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                
              </v-select>

              <v-select v-if="refreshingLsaAccounts" :items="[]"
                outlined dense
                hide-details style="width: 100%; font-size: 12px;"
                placeholder="Refreshing..."
                >
                
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field v-model="searchTerm" placeholder="Search" @input="searchAccounts"></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                
              </v-select>
            </div>
            
          </div>
        </div>

        <div class="flex flex-wrap">
          <div :class="'w-full md:w-1/2 mb-3 md:mb-0' + (($vuetify.breakpoint.mobile) ? '' : ' pr-5')">
            <p class="mb-1 text-xs mb-2"><strong>
              Country
            </strong></p>
            
            <v-select
              :items="countries"
              label=""
              item-text="name"
              item-value="code"
              hide-details
              v-model="business_location.country"
              class="-mt-2 bg-grey"
              dense
              outlined
            ></v-select>
          </div>

          <div :class="'w-full md:w-1/2 mb-3 md:mb-0'">
            <p class="mb-1 text-xs mb-2"><strong>
              City
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" v-model="business_location.city">
          </div>
        </div>

        <div class="flex flex-wrap">
          <div :class="'w-full mb-3 md:mb-0'">
            <p class="mb-1 text-xs mb-2"><strong>
              Address
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" v-model="business_location.address">
          </div>
        </div>

        <div class="flex flex-wrap">
          <div :class="'w-full md:w-1/2 mb-3 md:mb-0' + (($vuetify.breakpoint.mobile) ? '' : ' pr-5')">
            <p class="mb-1 text-xs mb-2"><strong>
              <span v-if="business_location.country == 'US'">State</span>
              <span v-if="business_location.country != 'US'">County</span>
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" v-model="business_location.state">
          </div>

          <div :class="'w-full md:w-1/2 mb-3 md:mb-0'">
            <p class="mb-1 text-xs mb-2"><strong>
              <span v-if="business_location.country == 'US'">Zip</span>
              <span v-if="business_location.country != 'US'">Postal Code</span>
            </strong></p>
            <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" v-model="business_location.zip">
          </div>
        </div>

        <div class="flex flex-wrap">
            <div class="w-full md:w-2/2 mb-3 md:mb-0">
                <p class="mb-1 text-xs mb-2"><strong>
                    Optional
                </strong></p>
                <v-checkbox
                  v-model="loginEnabled"
                  label="Create Login"
                  value="yes"
                  hide-details
                   :ripple="false"
                ></v-checkbox>
            </div>
        </div>

        <div v-if="loginEnabled" class="flex flex-wrap">
            <div class="w-full mb-3 md:mb-0">
                <p class="mb-1 text-xs mb-2"><strong>
                    Password
                </strong></p>
                <input name="password" ref="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="password">
            </div>

            <!-- <div class="w-full mb-3 md:mb-0" style="font-size: 12px;">
                A confirmation link will be sent to the customer to verify their email address.
              </div> -->
        </div>
      </div>

      <div class="bg-gray-100 rounded-b-lg px-6 py-4">

        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': saving}" :disabled="saving" @click="save">
            SAVE
        </button>

        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="hide">
            CANCEL
        </button>

        <div class="clearfix"></div>

      </div>



    </div>
  </div>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { GetSuggestions } from '@/utils/PlaceUtils'
import $ from 'jquery'
import countries from '@/config/countries';
import VueGoogleAutocomplete from "vue-google-autocomplete";
import vSelect from "vue-select";

export default {
  components: {
    VueGoogleAutocomplete,
    vSelect
  },

  data: function() {
    return {
      showModal: false,
      onboardingRequestId: null,
      saving: false,
      success: null,
      error: null,
      loginEnabled: false,

      company_name: "",
      main_keyword: "",
      lsa_client_account_id: null,

      autocompleteLocationModel: null,
      locationSearchText: null,
      locationEntries: [],

      business_location: {
        country: "US"
      },

      countries: countries,

      searchTerm: "",

      lsaAccountsCopy: [],

      refreshingLsaAccounts: false
    }
  },
  props: ['is_business', 'is_agency', 'redirect_to_onboarding'],
  computed: {
    googleConnected () { return !!(this.me && this.me.integrations && this.me.integrations.google_ads && Number(this.me.integrations.google_ads.status) === 1) },
    googleClients () { const settings = (this.me && this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.settings) || {}; const manager = (settings.original_managers || {})[settings.selected_manager_id]; return manager && Array.isArray(manager.clients) ? manager.clients : [] },
    locationFoundItems () {
      return this.locationEntries
    },
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile
    })
  },
  methods: {
    show() {
      if (this.redirect_to_onboarding && !this.onboardingRequestId) this.onboardingRequestId = crypto.randomUUID()
      this.showModal = true
    },
    hide() {
      this.showModal = false
      this.saving = false
    },
    getAddressObject(address_components) {
      var ShouldBeComponent = {
        street_number: ["street_number"],
        zip: ["postal_code"],
        address: ["street_address", "route"],
        state: [
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "administrative_area_level_4",
          "administrative_area_level_5"
        ],
        city: [
          "locality",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4"
        ],
        country: ["country"]
      };

      var address = {
        street_number: "",
        zip: "",
        address: "",
        state: "",
        city: "",
        country: ""
      };
      address_components.forEach(component => {
        for (var shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === "country") {
              address[shouldBe] = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });
      return address;
    },
    async refreshLsaAccounts() {
      this.refreshingLsaAccounts = true

      this.me.integrations.google_ads.settings.original_managers = [];

      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/refresh-lsa-accounts`, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
            'Content-Type': 'multipart/form-data'
          }
      })

      this.me.integrations.google_ads = response.data.integration;

      this.refreshingLsaAccounts = false
    },

    async save() {
      if (this.saving) return
      this.saving = true
      this.error = null
      try {

        let formData = new FormData();
        // formData.append("name", this.name);
        formData.append("first_name", this.$refs.first_name.value);
        formData.append("last_name", this.$refs.last_name.value);
        formData.append("company_name", this.company_name);
        formData.append("main_keyword", this.main_keyword);
        formData.append("email", this.$refs.email.value);

        if (this.loginEnabled)
            formData.append("password", this.$refs.password.value);

        if (this.lsa_client_account_id)
          formData.append("lsa_client_account_id", this.lsa_client_account_id);

        formData.append("loginEnabled", this.loginEnabled);

        formData.append("street_number", this.business_location.street_number || "");
        formData.append("address", this.business_location.address || "");
        formData.append("city", this.business_location.city || "");
        formData.append("state", this.business_location.state || "");
        formData.append("zip", this.business_location.zip || "");
        formData.append("country", this.business_location.country || "");
        formData.append("lat", this.business_location.lat || "");
        formData.append("lng", this.business_location.lng || "");
        formData.append("place_id", this.business_location.place_id || "");
        
        if (this.is_agency) formData.append("is_agency", this.is_agency);

        if (this.redirect_to_onboarding) formData.append('onboarding_request_id', this.onboardingRequestId);
        const endpoint = this.redirect_to_onboarding ? `/onboarding/journey/${this.me.id}/business` : '/me/children/add';
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}${endpoint}`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
              'Content-Type': 'multipart/form-data'
            }
        })

        if (typeof(this.is_business) != "undefined") {
          // window.location = window.location.origin + '/login?alt=' + btoa(response2.data.jwt_token);
          // this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }});
          await this.switchLocation(response.data.child.uuid);
          return;
        }
        else {
          //this.hide()
          this.hide()
          // this.$store.state.contacts.fetchingContacts = true
          this.$store.dispatch('businesses/fetch')
          this.$store.dispatch('locations/fetch')
          this.error = null

          if (this.$store.state.me.me.company_type == 'agency')
            this.$store.dispatch('stats/fetch')
        }

      } catch (error) {
        const data = error.response && error.response.data;
        this.error = (data && (data.message || (data.errors && Object.values(data.errors).flat().join(' ')))) || 'Could not save or open the business. Check Businesses before retrying, to avoid a duplicate.';
      }
      this.saving = false

      // if (typeof(this.is_business) != "undefined")
      //   if (this.$route.name != "locations")
      //     this.$router.push('/locations')
    },

    async switchLocation(email) {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?email=${encodeURIComponent(email)}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (this.me.company_type == "admin") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&admin=true&admin_jwt_token=" + btoa(this.$store.state.auth.jwt);
        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), admin: true, admin_jwt_token: btoa(this.$store.state.auth.jwt) }});
      }
      else if (this.me.company_type == "agency") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt);
        if (this.is_agency) {
          const query = { alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }
          if (this.redirect_to_onboarding)
            query.redirect = 'onboarding'
          this.$router.push({ name: 'login', query: query});
        }
        else {
          const query = { alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }
          if (this.redirect_to_onboarding)
            query.redirect = 'onboarding'
          this.$router.push({ name: 'login', query: query });
        }
      }
      else {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token);

        // if (this.profile.company_type == 'user')
        //   this.$store.state.business_user = this.profile;

        // this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token) }});

        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token) }});
      }
    },


    filterPlaces (item, queryText, itemText) {
      return true
    },
    selectPlace(addressData, placeResultData, id) {
      let that = this

      //$.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + placeResultData.place_id + "&fields=name,rating,formatted_phone_number&key=AIzaSyANqXQPtxZhmpNYyvoBPBrnatNxGMvN9Ks", function(response) {
	$.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + placeResultData.place_id + "&fields=name,rating,formatted_phone_number&key=AIzaSyDpwiwzDnD_8Z98HKGNP_RWgreWRWY2GLM", function(response) {
        that.company_name = placeResultData.name;

        let address = that.getAddressObject(response.results[0].address_components);
        let business_location = {};
        business_location.street_number = address.street_number;
        business_location.address = address.address;
        business_location.city = address.city;
        business_location.state = address.state;
        business_location.zip = address.zip;
        business_location.country = address.country;

        business_location.lat = response.results[0].geometry.location.lat;
        business_location.lng = response.results[0].geometry.location.lng;
        business_location.place_id = response.results[0].place_id;

        that.business_location = business_location;

        let main_keyword = "";

        // Charlotte Christian Law

        if (response.results[0].types.length > 0) {
          for (var i in response.results[0].types) {
            if (response.results[0].types[i] != "establishment" && response.results[0].types[i] != "point_of_interest" && !that.main_keyword) {
              that.main_keyword = response.results[0].types[i].replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) {
                  return letter.toUpperCase();
              });
            }
          }
        }
      });
    },

    searchAccounts(e) {
      if (!this.searchTerm) {
        this.me.integrations.google_ads.settings.original_managers[this.me.integrations.google_ads.settings.selected_manager_id].clients = this.lsaAccountsCopy;
      }

      this.me.integrations.google_ads.settings.original_managers[this.me.integrations.google_ads.settings.selected_manager_id].clients = this.lsaAccountsCopy.filter((account) => {
        return account.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    }
  },watch: {
    locationSearchText (newVal) {
      var that = this;

      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 3) return

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function (res) {
          
          that.locationEntries = res
        })
        .catch(function () {
          that.business = false;
          that.step = 1;
        })
    },
  },

  mounted() {
    let self = this;
    // console.log('a1');
    setTimeout(function() {
      // console.log(self.me.integrations.google_ads.settings);
      if (self.me.integrations.google_ads.settings.original_managers) {
      // console.log('a2');
        self.lsaAccountsCopy = [...self.me.integrations.google_ads.settings.original_managers[self.me.integrations.google_ads.settings.selected_manager_id].clients];

        // console.log('self.lsaAccountsCopy', self.lsaAccountsCopy)

        // console.log('a3');
      }
    }, 3000);
  },
}
</script>

<style type="text/javascript">
  #rg_map {
    font-size: 12px;
    border-radius: 5px !important;
    height: 44px;
    background: rgba(25, 35, 58, 0.05) !important;
    border: 0px;
    margin-bottom: 14px;
  }
</style>